import { loadingAction } from "ReduxReducers/loadingReducer";
import axios from "axios";
import { appConstants } from "./appConstants";
import { CurrencyAction } from "ReduxReducers/currencyReducer";

export const login = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/checkLoginDetails", values)
    .then((res) => {
      dispatch(CurrencyAction(res.data.Result_Output?.currencyValue));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  login===>", error.message);
    });
};

export const sendOTPToUser = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/sendOTP", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  sendOTPToUser===>", error.message);
    });
};
export const wizardSignup = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/wizardSignup", values)
    .then((res) => {
      dispatch(CurrencyAction(res.data.Result_Output?.currencyValue));
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  wizardSignup===>", error.message);
    });
};
export const validateOTP = async (values, apiPath, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + apiPath, values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error.response?.data) callBack(error.response.data);
      else
        callBack({
          Result_Status: false,
          Result_Message: "Unable to verify your email. Please try again.",
        });
      console.log("error  validateOTP===>", error.message);
    });
};
export const changePass = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/changePass", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  changePass===>", error.message);
    });
};
export const forgotUserPassword = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/forgotPassword", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  forgotUserPassword===>", error.message);
    });
};

export const userResendOTP = async (values, apiPath, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + apiPath, values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  userResendOTP===>", error.message);
    });
};

export const userResetPassword = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/resetPassword", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error.response?.data) callBack(error.response.data);
      console.log("error  userResetPassword===>", error.message);
    });
};
export const googleSigin = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/googleSigin", values)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  googleSigin===>", error.message);
    });
};

export const facebookSignin = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/facebookSignin", values)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  facebookSignin===>", error.message);
    });
};

/*<==================================CUSTOMER LOGIN==========================>*/

export const customerLogin = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/checkLoginDetails", values)
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  customerLogin===>", error.message);
    });
};

export const newCustomerSignUp = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/customerSignUp", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  newCustomerSignUp===>", error.message);
    });
};

export const forgotPasswordCustomer = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/forgotPassword", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  forgotPasswordCustomer===>", error.message);
    });
};

export const setCustomerPassword = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/setPassword", values)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error  setCustomerPassword===>", error.message);
    });
};

export const getShippingCompany = async (values, callBack) => {
  axios
    .get(appConstants.baseURL + "customer/fetchShippingCompany", values)
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error  getShippingCompany===>", error.message);
    });
};
